import {APP_CONFIG} from "../config";

export default  {
    /*
        POST /v1/clients/web/admin/login
     */
    attemptLogin(payload){
        if(payload.channel === 'social') {
            return this.socialLogin(payload);
        }
        return axios.post(payload.requestOptions.loginUrl, payload.user)
    },

    logOut(payload){
        return axios.delete(payload.endPoint, payload.options);
    },

    getTokenFromRefresh(payload){
        return axios.post(payload.endPoint, {
            refresh_token: payload.refreshToken
        });
    },

    socialLogin(params) {
        return axios.post(`${APP_CONFIG.URL}auth/${params.provider}/callback`, {
            code: params.code
        })
    }
}
